import React from 'react';

type StepPageContextType = {
  activeStepIndex: number;
  activeSubStepIndex: number;
  setActiveStep(
    activeStepIndex: number,
    activeSubStepIndex: number,
  ): Promise<void>;
};

export const StepPageContext = React.createContext<StepPageContextType | null>(
  null,
);
